<template lang="html">
  <div :class="{ 'h-screen': $attrs.type == 'single' }">
    <div
      :style="{ 'min-height': topHeight + 'px' }"
      class="poll-top text-center"
    >
      <div class="logo pt-4 pb-4  lg:mt-16">
        <img
          v-if="$attrs.custom.logo"
          class="w-16 md:w-auto md:max-w-xs mx-auto"
          v-bind:src="$attrs.custom.logo"
        />
      </div>
      <div class="question px-4 sm:text-xl md:text-2xl lg:text-3xl">
        <span class="block w-full">
          <span v-if="$attrs.poll.question">
            {{ $attrs.poll.question }}
          </span>
        </span>
        <!--<a
          v-if="countAnswers > 2 && !voted"
          class="border p-2 px-4 inline-block text-base mt-4 block"
          >All Answers</a
        >-->
      </div>
      <!-- Already Voted -->
      <div class="px-4">
        <span
          v-if="$attrs.gate"
          class="block text-2xl w-full my-4 font-semibold"
          >{{ thanks }}</span
        >

        <span
          v-if="$attrs.gate && $attrs.poll.custom_answer"
          class="block mb-2"
          >{{ $attrs.poll.custom_answer }}</span
        >
        <span v-if="$attrs.gate" class="m-4 block p-4">
          The final results will be displayed here after
          {{ getHumanDate($attrs.poll.endDate + ":" + $attrs.poll.endTime) }}
          GMT
        </span>
      </div>

      <span class="block" v-if="$attrs.type == 'group'">
        <span v-if="$route.params.pollId != 0">
          <button
            @click="lastPoll($route.params.pollId)"
            class="mt-4 w-2/3 md:w-auto text-white md:mr-2 py-1 md:py-4 pr-8 pl-2 text-xl bg-gray-500  shadow-lg"
            v-if="(voted && $attrs.type != 'single') || $attrs.gate"
          >
            <span class="px-2 md:py-2 md:px-4"
              ><i class="fas fa-chevron-left"></i
            ></span>
            Last Poll
          </button>
        </span>

        <span v-if="!$attrs.last">
          <button
            v-if="(voted && $attrs.type != 'single') || $attrs.gate"
            type="button"
            class="w-2/3 md:w-auto mt-2 lg:mt-16 text-white py-1 md:py-4 pl-8 pr-2 text-xl bg-gray-500 shadow-lg"
            name="next"
            @click="next($route.params.pollId)"
          >
            Next Poll
            <span class="px-2 md:py-2 md:px-4"
              ><i class="fas fa-chevron-right"></i
            ></span>
          </button>
        </span>
        <span
          class="p-3 text-xl  block mt-16 bg-push-blue text-white"
          v-if="voted && $attrs.type != 'single' && $attrs.last"
        >
          {{ $attrs.groupthanks }}
        </span>
      </span>

      <div
        class="m-4 p-4 "
        v-if="$attrs.poll.endDate + ':' + $attrs.poll.endTime <= currentDate"
      >
        <!-- If Ended -->
        This poll ended on
        <br />
        {{ getHumanDate($attrs.poll.endDate + ":" + $attrs.poll.endTime) }} GMT.
        <br />
        Below are the final results
      </div>

      <div
        class="m-4 bg-push-lightgray p-4 border"
        v-if="
          $attrs.poll.startDate + ':' + $attrs.poll.startTime >= currentDate
        "
      >
        <!-- If Not started -->
        This poll starts on:
        <br />
        {{ getHumanDate($attrs.poll.startDate + ":" + $attrs.poll.startTime) }}
        GMT
      </div>
    </div>
    <!-- Poll Answering -->
    <div
      :style="{ 'min-height': bottomHeight + 'px' }"
      class="poll-bottom text-center mt-4 flex flex-wrap"
    >
      <!-- Answers -->
      <a
        @click="vote(i)"
        v-for="(answer, i) in $attrs.poll.answers"
        v-bind:key="i"
        class="w-1/2 pt-4 cursor-pointer"
        :class="grid"
        v-bind:style="{ background: customStylesBg(i) }"
      >
        <!-- Answered Label-->

        <span
          v-if="(voted && $attrs.gate) || !$attrs.open"
          class="md:text-xl h-12 leading-none mb-8 block w-full px-2"
          v-bind:style="{ color: customStylesFg(i) }"
          >{{ answer.label }}</span
        >
        <span
          v-else
          class="text-xl h-12 leading-none mb-8 block w-full px-2"
          v-bind:style="{ color: customStylesFg(i) }"
          >{{ answer.label }}</span
        >
        <span
          v-if="!$attrs.gate && $attrs.open"
          class="circle-container block relative rounded-full mx-auto"
          :class="{ 'border-8': !voted }"
          v-bind:style="{
            'border-color': customStylesFg(i),
            width: progressCircle.diameter + 'px',
            height: progressCircle.diameter + 'px'
          }"
        >
          <span class="circle  absolute left-0 w-full object-center -mt-1">
            <span
              v-if="!voted"
              class=" leading-none text-2xl "
              v-bind:style="{ color: customStylesFg(i) }"
            ></span>

            <radial-progress-bar
              v-if="voted"
              class="text-2xl lg:text-4xl leading-none"
              :diameter="progressCircle.diameter"
              :completed-steps="answer.answer_count"
              :total-steps="$attrs.poll.total"
              :strokeWidth="8"
              :innerStrokeColor="customStylesFg(i)"
              :stopColor="customStylesFg(i)"
              :startColor="customStylesFg(i)"
            >
              <span
                class="text-xs"
                v-bind:style="{ color: customStylesFg(i) }"
                v-if="voteDelay"
                ><i class="far fa-hourglass"></i>
              </span>
              <span v-else>
                <span
                  v-bind:style="{ color: customStylesFg(i) }"
                  v-if="$attrs.poll.total > 0"
                  >{{
                    Math.round((answer.answer_count / $attrs.poll.total) * 100)
                  }}<span class="text-xs">%</span></span
                >
                <span
                  v-bind:style="{ color: customStylesFg(i) }"
                  v-else="$attrs.poll.total === 0"
                  >0 <span class="text-xs">%</span></span
                >
              </span>
            </radial-progress-bar>
          </span>
        </span>

        <!-- if answered -->

        <span
          v-if="$attrs.gate || !$attrs.open"
          class="circle-container block relative rounded-full  mx-auto "
          :style="{
            width: progressCircle.diameter + 'px',
            height: progressCircle.diameter + 'px'
          }"
        >
          <span class="circle absolute left-0 w-full object-center -mt-1">
            <radial-progress-bar
              class="text-2xl leading-none block"
              :diameter="progressCircle.diameter"
              :completed-steps="answer.answer_count"
              :total-steps="$attrs.poll.total"
              :strokeWidth="8"
              :innerStrokeColor="customStylesFg(i)"
              :stopColor="customStylesFg(i)"
              :startColor="customStylesFg(i)"
            >
              <span>
                <span
                  v-bind:style="{ color: customStylesFg(i) }"
                  v-if="$attrs.poll.total > 0"
                  >{{
                    Math.round((answer.answer_count / $attrs.poll.total) * 100)
                  }}<span class="text-xs">%</span></span
                >
                <span
                  v-bind:style="{ color: customStylesFg(i) }"
                  v-else="$attrs.poll.total === 0"
                  >0 <span class="text-xs">%</span></span
                >
              </span>
            </radial-progress-bar>
          </span>
        </span>
      </a>
    </div>
  </div>
</template>

<script>
import firebase from "firebase/app";
import moment from "moment";
import RadialProgressBar from "vue-radial-progress";
export default {
  components: {
    RadialProgressBar
  },
  data() {
    return {
      thanks: "Thanks, you have already voted on this poll",
      progressCircle: {
        diameter: null,
        stopColor: "orange",
        startColor: "orange",
        innerStrokeColor: "transparent"
      },
      height: null,
      voteDelay: true,
      voted: null
    };
  },
  created() {
    window.addEventListener("resize", this.WindowHeight);
    window.addEventListener("resize", this.WindowWidth);
  },
  destroyed() {
    window.removeEventListener("resize", this.WindowHeight);
    window.removeEventListener("resize", this.WindowWidth);
  },
  mounted() {
    this.WindowHeight();
    this.WindowWidth();
    this.ifGate();
    this.ifClosed();
  },
  computed: {
    grid() {
      var grid = "lg:w-1/2";
      if (this.countAnswers < 3) {
        grid = "lg:w-1/2";
      }
      if (this.countAnswers == 3) {
        grid = "sm:w-1/3";
      }
      if (this.countAnswers == 4) {
        grid = "lg:w-1/4";
      }
      if (this.countAnswers > 4) {
        grid = "lg:w-1/5";
      }
      return grid;
    },
    topHeight() {
      return this.height / 3;
    },
    bottomHeight() {
      return (this.height / 3) * 2;
    },
    multipleAnswerHeight() {
      return (this.bottomHeight / 2) * 1.5;
    },
    pollData() {
      return this.$attrs.poll;
    },
    currentDate() {
      var today = moment().format("YYYY-MM-DD:HH:mm");
      return today;
    },
    countAnswers() {
      let polls = this.pollData;
      if (polls.answers) {
        return polls.answers.length;
      }
    }
  },
  methods: {
    ifGate() {
      if (this.$attrs.gate) {
        return (this.voted = true);
      }
    },
    ifClosed() {
      if (!this.$attrs.open) {
        return (this.voted = true);
      }
    },
    WindowWidth(e) {
      var windowWidth = window.innerWidth;
      this.progressCircle.diameter = 180;
      if (windowWidth < 980) {
        this.progressCircle.diameter = 140;
      }
      if (windowWidth < 600) {
        this.progressCircle.diameter = 120;
      }
    },
    customStylesBg(index) {
      var style = "";
      var custom = this.$attrs.custom;
      if (index % 2 === 0) {
        //odd
        style = custom.obgcolor;
      } else {
        //even
        style = custom.ebgcolor;
      }
      return style;
    },

    customStylesFg(index) {
      var style = "";
      var custom = this.$attrs.custom;
      if (index % 2 === 0) {
        //odd
        style = custom.otcolor;
      } else {
        //even
        style = custom.etcolor;
      }
      return style;
    },

    customResultsCircle() {
      var custom = this.$attrs.custom;

      this.startColor = custom.otcolor;
      this.stopColor = custom.otcolor;
    },

    addCookie() {
      var id = this.$attrs.poll.pollkey;
      var voted = { poll: id };
      this.$cookies.set("vote" + id, voted);
      console.log("vote" + this.$attrs.poll.pollkey);
    },

    next(id) {
      this.voted = false;
      this.$router.push({
        name: "groupsingle",
        params: { pollId: Number(id + 1) }
      });
    },
    lastPoll(id) {
      this.voted = false;
      this.$router.push({
        name: "groupsingle",
        params: { pollId: Number(id - 1) }
      });
    },

    vote(vote) {
      var id = this.$attrs.poll.pollkey;
      var vm = this;
      if (vm.voted || vm.$attrs.gate || !vm.$attrs.open) {
        return;
      }
      this.voted = true;
      vm.pollData.answers[vote].answer_count += 1;
      vm.thanks = "Thanks for voting";

      //Add cookies
      this.addCookie();
      setTimeout(function() {
        vm.voteDelay = false;
        //vm.pollData.total += 1
        let answers = vm.pollData.answers;
        //Log on Firebase
        var firestore = firebase.firestore();
        var pollRef = firestore.collection("polls").doc(String(id));

        pollRef
          .update({
            answers,
            total: firebase.firestore.FieldValue.increment(1)
          })
          .then(function() {
            console.log("Answer successfully updated!");
          })
          .catch(function(error) {
            // The document probably doesn't exist.
            console.error("Error updating document: ", error);
          });
      }, 1000);
    },
    WindowHeight() {
      this.height = window.innerHeight;
    },
    getHumanDate(date) {
      return moment(date, "YYYY-MM-DD:LTS").format("LLLL");
    }
  }
};
</script>
